import { api } from "../../api/api"

export const NodeREDScreen = () => {
    return (<iframe
        src={api().nodeRed}
        title='Node-RED'
        style={{ width: '100%', height: '100%' }}
        allowFullScreen
    ></iframe>)
}